import React from          "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"


const Dot = ({ tooltip, color, popupAction }) =>
<span
  className="resource-title-dot mr-1"
  style={{ backgroundColor: color }}
  onMouseEnter = { popupAction ? e => popupAction({ x: e.pageX, y: e.pageY, content: tooltip }): null}
  onMouseLeave = { popupAction ? () => popupAction(false): null}
/>

const Info = ({ info, popupAction }) =>
<span
  className="mt-1 mr-1"
  onMouseEnter={e => popupAction({ x: e.pageX, y: e.pageY, content: info })}
  onMouseLeave={() => popupAction(false)}
>
  <FontAwesomeIcon icon='info-circle' className="ml-1" />
</span>

// "3h30" style formatting for a number of minutes.
const formatMinutes = minutes => {
  const h = Math.floor(minutes / 60)
  const m = Math.round(minutes % 60)
  return m > 0 ? `${h}h${String(m).padStart(2, '0')}` : `${h}h`
}

// Planned load vs day capacity pill (single-day views). Capacity comes from
// the per-weekday businessHours; load from the events currently displayed.
const LoadPill = ({ nodeId, dayLoads, rawResources, currentDate }) => {
  if (!dayLoads || !currentDate) return null

  const load = dayLoads[String(nodeId)] || 0
  const raw  = (rawResources || []).find(r => String(r.id) === String(nodeId))
  let capacity = null
  if (raw && raw.businessHours) {
    const weekday = new Date(currentDate).getDay()
    const slot    = raw.businessHours.find(bh => (bh.daysOfWeek || []).includes(weekday))
    if (slot) {
      const toMin = hm => parseInt(hm.slice(0, 2), 10) * 60 + parseInt(hm.slice(3, 5), 10)
      capacity = toMin(slot.endTime) - toMin(slot.startTime)
    } else {
      capacity = 0 // scheduled day off
    }
  }

  if (load === 0 && (capacity === null || capacity === 0)) return null

  let tone = 'neutral'
  if (capacity !== null) {
    if (capacity === 0)                 tone = 'over'
    else if (load > capacity)           tone = 'over'
    else if (load >= capacity * 0.8)    tone = 'warn'
    else                                tone = 'ok'
  }

  const label = capacity ? `${formatMinutes(load)}/${formatMinutes(capacity)}` : formatMinutes(load)
  return (
    <span className={`load-pill load-pill--${tone}`} title={I18n.t('calendar.load_pill_title')}>
      {label}
    </span>
  )
}

const UserLabel = ({ resource, popupAction, dayLoads, rawResources, currentDate, onOpenAbsences }) => {
  const node  = resource.resource._resource
  const props = node.extendedProps
  const title = node.title

  // ── Material resources hierarchy: group ▸ category ▸ resource ──────────
  if (props.resourceGroup) {
    return <span className="resource-group-title">{title}</span>
  }
  if (props.resourceCategory) {
    return (
      <span className="flex resource-label resource-category-title">
        <Dot color={props.color}/>
        <span className="mr-1 resource-label__name" title={title}>{title}</span>
      </span>
    )
  }
  if (props.resource) {
    return (
      <span className="flex resource-label">
        <Dot color={props.color}/>
        <span className="mr-1 resource-label__name" title={props.name || title}>{props.name || title}</span>
      </span>
    )
  }

  // Clicking a technician opens their leaves & absences.
  const user      = props
  const clickable = !!onOpenAbsences
  return (
    <span className="flex resource-label">
      <Dot color={user.color}/>
      <span
        className = {`mr-1 resource-label__name${clickable ? ' resource-absences-link' : ''}`}
        title     = {clickable ? I18n.t('users.absences.open_for_user', { name: user.name }) : user.name}
        onClick   = {clickable ? () => onOpenAbsences(node.id) : null}
      >
        { user.name }
      </span>
      { user.information && <Info info={user.information} popupAction={popupAction}/> }

      { user.domains && user.domains.map(domain =>
        <Dot
          key         = {domain.id}
          color       = {domain.color}
          tooltip     = {domain.name}
          popupAction = {popupAction}
        />)
      }

      <LoadPill
        nodeId       = {node.id}
        dayLoads     = {dayLoads}
        rawResources = {rawResources}
        currentDate  = {currentDate}
      />
    </span>
  )
}
export default UserLabel
